import { ReactNode, useMemo } from 'react';
import {
  Center,
  Drawer,
  Input,
  InputWrapperProps,
  useInputProps,
} from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';
import dayjs from 'dayjs';

import { InputSelect } from './input-select';

type SelectValue = { value: string; label: string };

const closeButtonProps = { size: 'lg' };

type UiFullpageSelectProps = {
  value?: Date;
  label?: ReactNode;
  minDate?: Date;
  hideOutsideDates?: boolean;
  placeholder?: ReactNode;
  listLoading?: boolean;
  data?: SelectValue[];
  onChange?: (date: Date) => void;
} & Pick<InputWrapperProps, 'mt'>;

export const UiFullScreenDatePicker = ({
  value,
  minDate,
  hideOutsideDates,
  placeholder,
  label,
  onChange,
  ...props
}: UiFullpageSelectProps) => {
  const { wrapperProps } = useInputProps(
    'TextInput',
    {},
    {
      value,
      placeholder,
      label,
      onChange,
      ...props,
    }
  );
  const [opened, { open, close }] = useDisclosure(false);

  const handleInputClick = () => open();

  const selectedValueLabel = useMemo(() => {
    const result = dayjs(value).format('DD.MM.YYYY');

    return result;
  }, [value]);

  const handleSelectDate = (value: Date) => {
    onChange && onChange(value);
    close();
  };

  return (
    <Input.Wrapper {...wrapperProps} size="md">
      <Drawer
        size="100%"
        position="bottom"
        opened={opened}
        title={placeholder}
        closeButtonProps={closeButtonProps}
        onClose={close}
      >
        <Center>
          <DatePicker
            minDate={minDate}
            hideOutsideDates={hideOutsideDates}
            size="md"
            value={value}
            onChange={handleSelectDate}
          />
        </Center>
      </Drawer>

      <InputSelect
        value={{ value: '', label: selectedValueLabel }}
        placeholder={placeholder}
        onClick={handleInputClick}
      />
    </Input.Wrapper>
  );
};
